import { render, staticRenderFns } from "./versatileAnswersRecord.vue?vue&type=template&id=e8b7973a&scoped=true"
import script from "./versatileAnswersRecord.vue?vue&type=script&lang=js"
export * from "./versatileAnswersRecord.vue?vue&type=script&lang=js"
import style0 from "./versatileAnswersRecord.vue?vue&type=style&index=0&id=e8b7973a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b7973a",
  null
  
)

export default component.exports